import * as React from 'react';
import { Input, Select } from 'antd';
import StaticView from './StaticView';
const Option = Select.Option;
const InputGroup = Input.Group;

interface iState {
    options: Array<{
        name: string;
        value: string;
    }>;
    selectValue: string;
    inputValue: string;
    addonAfter: string;
}

export default class SelectGroup extends React.Component<any, iState> {
    static fieldName = 'selectGroup';

    // 值变化
    changeHandler = (index: 0 | 1) => (data: string) => {
        const { onChange } = this.props;
        const { options, selectValue, inputValue } = this.state;
        if (index === 0) {
            const selectOption: any = options.filter((item: any) => item.value === data);
            this.setState({addonAfter: selectOption.length ? selectOption[0].addonAfter : ''});
        }
        this.setState({
            selectValue: index === 0 ? data : selectValue,
            inputValue: index === 1 ? data: inputValue
        }, () => {
            onChange && onChange([this.state.selectValue, this.state.inputValue]);
        });
    };

    // 失焦
    blurHandler = () => {
        const { value, onBlur } = this.props;
        onBlur && onBlur(value);
    };

    constructor(props: any) {
        super(props);
        this.state = {
            options: null,
            inputValue: '',
            selectValue: null,
            addonAfter: ''
        };
    }

    componentDidMount() {
        const { initialValue, options } = this.props;
        let selectValue = options.length && options[0].value || '';
        let addonAfter = options.length && options[0].addonAfter || '';
        if (initialValue && initialValue[0]) {
            selectValue = initialValue[0];
        }
        this.setState({ options, selectValue, addonAfter });
    }

    render() {
        const { placeholder, initialValue, disabled, staticView } = this.props;
        const { options, selectValue, addonAfter, inputValue } = this.state;
        return (
            (staticView && disabled)
                ? <StaticView display={initialValue} adaptFn={(val: any) => val && `(${val[0]}) ${val[1]}`}/>
                : options && <InputGroup compact style={{ height: 32 }}
                                         className={(staticView && disabled) ? 'Form-static-view' : ''}>
                <Select placeholder={placeholder[0]} value={(initialValue && initialValue[0] ? initialValue[0] : selectValue )}
                        dropdownMatchSelectWidth={false} dropdownStyle={{ width: 'auto' }}
                        onChange={(e: any) => this.changeHandler(0)(e)} style={{ width: "50%" }}
                        disabled={disabled}>
                    {options && options.map(({ name, value }) =>
                        <Option key={value} title={name}>{name}</Option>)}
                </Select>
                <Input placeholder={placeholder[1]} value={(initialValue && initialValue[1] ? initialValue[1] : inputValue )}
                       onChange={(e: any) => this.changeHandler(1)(e.target.value)} onBlur={this.blurHandler}
                       style={{ width: "50%", paddingTop: 1 }} disabled={disabled} addonAfter={addonAfter}/>
            </InputGroup>
        );
    }
}
